'use strict'

module.exports = {
  WHEEL: 1,
  SCRATCH_OFF: 2,
  SLOT_MACHINE: 3,
};
